export default function GalleryIcon({ className="", onClick=null }) {
  return (
    <>
      <svg
        className={className}
        onClick={onClick}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 500 500"
      >
        <path d="M433.09,428.28c0,6.46-5.26,11.72-11.72,11.72H78.62c-6.46,0-11.71-5.26-11.71-11.72s5.25-11.71,11.71-11.71h342.75c6.46,0,11.72,5.26,11.72,11.71Z"/>
        <path d="M424.43,153.52L255.61,61.44c-3.51-1.92-7.7-1.92-11.22,0l-168.82,92.09c-4.71,2.56-7.07,7.98-5.75,13.18,1.32,5.19,6,8.82,11.36,8.82h41.99v181.03h-16.42c-6.46,0-11.72,5.26-11.72,11.71s5.26,11.72,11.72,11.72h286.48c6.46,0,11.72-5.26,11.72-11.72s-5.26-11.71-11.72-11.71h-16.42v-181.03h42c5.36,0,10.02-3.62,11.35-8.82,1.33-5.19-1.03-10.62-5.74-13.18ZM199.91,356.54h-53.31v-181.03h53.31v181.03ZM276.64,356.54h-53.3v-181.03h53.3v181.03ZM353.39,356.54h-53.3v-181.03h53.3v181.03ZM127.13,152.09l122.87-67.02,122.88,67.02H127.13Z"/>
      </svg>
    </>
  );
}